import http from '@framework/utils/http'
import { API_ENDPOINTS } from '@framework/utils/api-endpoints'
import { useMutation, useQuery } from 'react-query'

const fetchOrderStatus = async () => {
  const { data } = await http.get(API_ENDPOINTS.ORDER_STATUS)
  return {
    data: data,
  }
}

export const fetchData = async (email: string, id: string) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_MAG_URL}/rest/V1/fsd/order/tracking-info?order_id=${id}&email=${email}`,
    )
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    const data = await response.json()

    if (data?.length == 0) {
      throw new Error('Please enter correct email and order id to get details')
    }

    return data
  } catch (error: any) {
    throw new Error('Error fetching data: ' + error.message)
  }
}
const useOrderStatusQuery = () => {
  return useQuery([API_ENDPOINTS.ORDER_STATUS], fetchOrderStatus)
}

const getTrackOrderData = async ({
  email,
  orderId,
}: {
  email: string
  orderId: string
}) => {
  return fetchData(email, orderId)
}

export { useOrderStatusQuery, fetchOrderStatus, getTrackOrderData }
